import useSWRMutation from "swr/mutation";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { putFetcher } from "@/lib/swr";

// Inline deadline editor for an unconfirmed task (assignee or admin).
// Picking a date PUTs the new dueAt; the reminder alarm re-arms server-side —
// stale Cloud Tasks pings become no-ops, so edits are always safe.
const TaskDueInput = ({
  endpoint,
  onSaved,
  dueAt,
  overdue,
  className,
}: {
  endpoint: string;
  onSaved: () => void;
  dueAt?: string | null;
  overdue: boolean;
  className?: string;
}) => {
  const { trigger, isMutating } = useSWRMutation(endpoint, putFetcher, {
    onSuccess: onSaved,
  });
  return (
    <Input
      type="date"
      value={dueAt?.slice(0, 10) ?? ""}
      disabled={isMutating}
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => {
        if (e.target.value)
          trigger({ dueAt: `${e.target.value}T23:59:59+08:00` });
      }}
      aria-label="Due date"
      className={cn(
        "h-7 w-[8.2rem] px-2 text-xs",
        overdue && "border-destructive text-destructive",
        className
      )}
    />
  );
};

export default TaskDueInput;
